import { Frequency, PlanItem, PlanKey, TaskTemplate } from '../types/family';

// Graditelji predlog nalog. Pravila izhajajo iz podatkov (vrsta, planKey, nosilci), nikoli iz imen.

type Base = Partial<TaskTemplate> & Pick<TaskTemplate, 'id' | 'title' | 'group' | 'module' | 'assigneeIds'>;

export function task(p: Base): TaskTemplate {
  return { confirmation: 'zaupanje', transferable: false, timed: false, ...p };
}

export const readingTask = (m: string, minutes: number) =>
  task({
    id: `branje-${m}`,
    title: 'Branje',
    group: 'rutina',
    module: 'osebnaRutina',
    assigneeIds: [m],
    targetMinutes: minutes,
    baseValue: 5,
    valueType: 'osnovno',
    planKey: 'branje',
    timed: true,
    extraMinutesBonus: true,
    frequency: { kind: 'dnevno', times: 1 },
  });

export const sportTask = (m: string, minutes: number) =>
  task({
    id: `sport-${m}`,
    title: 'Šport – intenzivna vadba',
    group: 'rutina',
    module: 'osebnaRutina',
    assigneeIds: [m],
    targetMinutes: minutes,
    baseValue: 5,
    valueType: 'osnovno',
    planKey: 'sport',
    timed: true,
    dueLabel: 'tedenski cilj',
  });

export const instrumentTask = (id: string, title: string, m: string) =>
  task({
    id,
    title,
    group: 'rutina',
    module: 'glasba',
    assigneeIds: [m],
    targetMinutes: 30,
    baseValue: 5,
    valueType: 'osnovno',
    planKey: 'instrument',
    timed: true,
    extraMinutesBonus: true,
    frequency: { kind: 'dnevno', times: 1 },
  });

export const learningTask = (m: string) =>
  task({
    id: `ucenje-${m}`,
    title: 'Domače naloge in učni plan',
    description: 'Vse, kar je za šolo dogovorjeno za danes – ena kljukica za ves dan.',
    group: 'sola',
    module: 'sola',
    assigneeIds: [m],
    baseValue: 5,
    valueType: 'osnovno',
    planKey: 'ucenje',
    timed: true,
    dueLabel: 'za danes',
  });

export const eveningTask = (m: string) =>
  task({
    id: `vecer-${m}`,
    title: 'Večerna rutina',
    description: 'Priprava za jutri, higiena in naprave odložene.',
    group: 'vecer',
    module: 'vecerniRezim',
    assigneeIds: [m],
    baseValue: 2,
    valueType: 'osnovno',
    planKey: 'vecer',
  });

export const roomWeekTask = (m: string) =>
  task({
    id: `soba-teden-${m}`,
    title: 'Soba',
    description: 'pospravljeno, posesano in brez prahu – ena celota, brez podtočk.',
    group: 'hisa',
    module: 'hisnaOpravila',
    confirmation: 'skrbnik',
    assigneeIds: [m],
    baseValue: 15,
    valueType: 'osnovno',
    planKey: 'soba',
    transferable: true,
    dueLabel: 'ves teden',
    frequency: { kind: 'tedensko', times: 1 },
  });

export const roomDayTask = (m: string, value: number) =>
  task({
    id: `soba-dan-${m}`,
    title: 'Urejena soba danes',
    group: 'hisa',
    module: 'hisnaOpravila',
    assigneeIds: [m],
    baseValue: value,
    valueType: 'bonus',
    dueLabel: 'goodies',
  });

export const beddingTask = (m: string, nextDue: string) =>
  task({
    id: `posteljnina-${m}`,
    title: 'Menjava posteljnine',
    group: 'hisa',
    module: 'hisnaOpravila',
    assigneeIds: [m],
    baseValue: 5,
    valueType: 'osnovno',
    transferable: true,
    frequency: { kind: 'mesecno' },
    nextDue,
    dueLabel: 'zadnja sobota v mesecu',
  });

export const houseTask = (id: string, title: string, ids: string[], value: number, description?: string) =>
  task({
    id,
    title,
    description,
    group: 'hisa',
    module: 'hisnaOpravila',
    confirmation: 'skrbnik',
    assigneeIds: ids,
    baseValue: value,
    valueType: 'osnovno',
    transferable: true,
    dueLabel: 'ves teden',
    frequency: { kind: 'tedensko', times: 1 },
  });

export const careTask = (
  id: string,
  title: string,
  ids: string[],
  animalIds: string[],
  value: number,
  frequency: Frequency,
  extra: Partial<TaskTemplate> = {}
) =>
  task({
    id,
    title,
    group: 'zivali',
    module: 'zivali',
    assigneeIds: ids,
    animalIds,
    baseValue: value,
    valueType: ids.length > 0 ? 'osnovno' : 'bonus',
    planKey: ids.length > 0 ? 'zivali' : undefined,
    transferable: true,
    frequency,
    ...extra,
  });

export const planItem = (
  key: PlanKey,
  label: string,
  unitWeight: number,
  required: number,
  doneBefore: number,
  extra: Partial<PlanItem> = {}
): PlanItem => ({ key, label, unitWeight, required, doneBefore, ...extra });
